<ngx-loading-bar [includeSpinner]="false"></ngx-loading-bar>
<app-toast aria-live="polite" aria-atomic="true"></app-toast>
<router-outlet></router-outlet>
